import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectUserId } from "@web-src/modules/auth/store/authSlice";
import { useTranslations } from "@jugl-web/utils";
import { useUserGeneralProfile } from "@jugl-web/domain-resources/users/hooks/useUserGeneralProfile";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";

const UserProfileName: React.FC<{
  userId?: string | null;
  suffix?: string;
  safe?: boolean;
}> = ({ userId, suffix, safe }) => {
  const meId = useSelector(selectUserId);
  const { entityId } = useEntitySelectedProvider();
  const { safeProfile, profile: unsafeProfile } = useUserGeneralProfile({
    entityId,
    userId: userId || undefined,
  });
  const profile = safe ? safeProfile : unsafeProfile;
  const { t } = useTranslations();

  const name = useMemo(() => {
    if (meId === userId) {
      return `${t({
        id: "common.you",
        defaultMessage: "You",
      })}${suffix || ""}`;
    }
    if (!profile) {
      return null;
    }
    return `${profile.displayName}${suffix || ""}`;
  }, [meId, userId, profile, suffix, t]);
  return <>{name}</>;
};

export default UserProfileName;
